var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0,0,0)",
      contentVisibility: "visible"
    }
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9700",
    d: "M144.945 115c-3.961-5.358-23.801-30.636-44-53a2571 2571 0 0 0-15.213-16.711c14.888-20.756 24.414-45.773 27.14-72.887C118.945-88 66.945-166-22.055-166c-76.987 0-139.89 60.202-133.935 147.74C-150.055 69-57.055 109-7.938 101.971c16.334-2.338 31.491-7.314 45.175-14.453A728 728 0 0 1 57.945 108c24.08 24.768 47.019 45.378 52 48 19 10 52-18 35-41m-55-168c5 3 7 17 5 21-1.844 3.688-16 7-19 4s-6-14-4-19 14.165-8.301 18-6m-157-71c-5-2-7-13-3-16 4.665-3.499 38.205-21.496 92 1 55 23 60 66 57 71s-14 8-17 0-17.973-37.17-50-51c-44-19-74.357-3.143-79-5",
    style: {
      display: "block"
    },
    transform: "matrix(1.56688 0 0 1.56688 261.615 262.86)"
  })));
};
export default SvgSearch;